import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ChevronRight, Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Global paywall modal — triggered by axios interceptor when a request returns 402 subscription_required
export function PaywallModal() {
  const { paywall, setPaywall } = useAuth();
  const navigate = useNavigate();
  if (!paywall.open) return null;
  const close = () => setPaywall({ open: false, message: "" });
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="paywall-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={close} />
      <div className="relative z-10 w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-br from-[#0a1e3a] to-[#003858] p-7 text-white">
          <div className="w-12 h-12 bg-[#B7EB1B] rounded-2xl flex items-center justify-center mb-4">
            <Sparkles className="w-6 h-6 text-[#0a1e3a]" />
          </div>
          <h2 className="text-2xl font-extrabold mb-2 leading-tight" style={{fontFamily: 'Manrope'}}>
            Start your free trial to send
          </h2>
          <p className="text-white/80 text-sm">
            {paywall.message || "You'll need an active subscription to send to your contact list."}
          </p>
        </div>
        <div className="p-7">
          <ul className="space-y-2 text-sm text-slate-700 mb-5">
            <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#0d9488] mt-0.5 flex-shrink-0" /> 14 days free, no credit card needed</li>
            <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#0d9488] mt-0.5 flex-shrink-0" /> All your drafts and contacts are saved</li>
            <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#0d9488] mt-0.5 flex-shrink-0" /> Cancel anytime in one click</li>
          </ul>
          <div className="flex flex-col-reverse sm:flex-row gap-2">
            <Button
              variant="outline"
              onClick={close}
              className="flex-1 rounded-full font-medium"
              data-testid="paywall-cancel"
            >
              Not now
            </Button>
            <Button
              onClick={() => { close(); navigate("/pricing"); }}
              data-testid="paywall-cta"
              className="flex-1 bg-[#B7EB1B] hover:bg-[#B7EB1B]/90 text-[#0a1e3a] rounded-full font-bold"
            >
              See plans <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
